import postTypes from '../../fieldOptions/postTypes'
import slugify from '../../slugify'

export default [
  {
    name: 'Author',
    prop: 'author_id',
    type: 'autocomplete',
    references: 'admin/users',
    referenceProp: 'fullname',
    displayProp: 'name',
    showIf: resource => resource.type !== 'monday_motivator'
  },
  { name: 'Title', prop: 'title', type: 'text' },
  { name: 'Body', prop: 'body', type: 'wysiwyg' },
  { name: 'Type', prop: 'type', type: 'select', options: postTypes },
  { name: 'URL', prop: 'slug', type: 'text', filter: slugify },
  { name: 'Publish Date', prop: 'publish_date', type: 'datetime' },
  { name: 'Feature Date', prop: 'feature_date', type: 'datetime', showIf: resource => resource.type === 'monday_motivator' },
  { name: 'Meta Title', prop: 'meta_title', type: 'text' },
  { name: 'Meta Keywords', prop: 'meta_keywords', type: 'text' },
  { name: 'Meta Description', prop: 'meta_description', type: 'text' },
  { name: 'Meta Image', prop: 'meta_image', type: 'text' }
]
